// material-ui
import { useTheme } from '@mui/material/styles';
import { FormControlLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material';
// project-imports
import Avatar from '../../../components/berry/ui-component/extended/Avatar';
import useConfig from '../../../hooks/useConfig';

// assets
import { IconMoon, IconSun } from '@tabler/icons-react';

// ==============================|| CUSTOMIZATION - MODE ||============================== //

const ThemeModeLayout = () => {
    const theme = useTheme();
    const { navType, onChangeMenuType } = useConfig();

    return (
        <Stack direction="row" alignItems="center" justifyContent="space-between" >

            <RadioGroup
                row
                aria-label="layout"
                value={navType}
                onChange={(e) => onChangeMenuType(e.target.value)}
                name="row-radio-buttons-group"
            >
                {theme.palette.mode === 'dark' ? (
                <FormControlLabel
                    control={<Radio value="light" sx={{ display: 'none' }} style={{ display: 'none' }} />}
                    label={
                        <Avatar
                            variant="rounded"
                            outline
                            sx={{
                                mr: 1,
                                width: 34,
                                height: 34,
                                ...(theme.palette.mode !== 'light' && { borderColor: theme.palette.divider + 20 })
                            }}
                        >
                            <IconSun color={theme.palette.warning.dark} />
                        </Avatar>
                    }
                />
                ) : (
                <FormControlLabel
                    control={<Radio value="dark" sx={{ display: 'none' }} style={{ display: 'none' }} />}
                    label={
                        <Avatar
                            size="md"
                            variant="rounded"
                            color="dark"
                            sx={{
                                width: 34,
                                height: 34,
                                ...(theme.palette.mode === 'dark' && { border: `2px solid ${theme.palette.primary.main}` })
                            }}
                        >
                            <IconMoon style={{ transform: 'rotate(220deg)', color: theme.palette.grey[100] }} />
                        </Avatar>
                    }
                />
                )}
            </RadioGroup>
        </Stack>
    );
};

export default ThemeModeLayout;
